import { Status, CallAPIAction } from 'api/types'
import type { GetLaborOfficesResponse } from 'api/evisaAPI/evisaAPI'
import type { LaborOffice, LaborOfficeFromBE } from 'common/types/transformedRespTypes'
import { formatObjectWithTranslationFromBE } from 'common/utils/objectWithTranslation'
import { StringRecord } from 'common/types/commonTypes'
import Actions from 'redux/actions'

export const formatOccupationsFromBE = (laborOfficeFromBE: LaborOfficeFromBE) => ({
  city_id: laborOfficeFromBE.city_id,
  ...formatObjectWithTranslationFromBE(laborOfficeFromBE),
})

const convertResponseToState = (resp: GetLaborOfficesResponse) =>
  resp.offices.reduce(
    (acc, laborOfficeFromBE) => ({
      ...acc,
      [laborOfficeFromBE.id]: formatOccupationsFromBE(laborOfficeFromBE),
    }),
    {},
  )

type State = {
  offices: StringRecord<LaborOffice>
} & Status

const initialState = {
  offices: {},
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABOR_OFFICES,
    Actions.GET_LABOR_OFFICES_SUCCESS,
    Actions.GET_LABOR_OFFICES_FAIL,
    GetLaborOfficesResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABOR_OFFICES: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.GET_LABOR_OFFICES_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        offices: convertResponseToState(payload),
        ...action.status,
      }
    }
    case Actions.GET_LABOR_OFFICES_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
